import { ADID_COUNT } from './../config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case ADID_COUNT:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;
